// frontend/src/components/responsive-fixes/LockdownBannerMobile.tsx
//
// Phone-friendly lockdown banner (audit M5). The desktop banner is a
// horizontal flex row (Layout.tsx:144-194) with icon + reason + email +
// dismiss button, all on one line. Below 600px the row wraps awkwardly;
// this component renders the same content as a vertical stack with the
// dismiss button right-aligned on its own row.
//
// Mounted by Layout.tsx conditionally on responsive.isPhone in place
// of the inline desktop banner. Same role="alert" semantics, same
// content, same handlers.

import React from "react";
import { BRAND } from "../../branding";

interface Props {
  reason?: string;
  contactEmail?: string;
  onDismiss: () => void;
}

const LockdownBannerMobile: React.FC<Props> = ({
  reason,
  contactEmail = "m.masoomi@gmail.com",
  onDismiss,
}) => {
  return (
    <div
      role="alert"
      className="lockdown-banner lockdown-banner--mobile"
      style={{
        background: "rgba(255,107,107,0.1)",
        border: "0.5px solid rgba(255,107,107,0.3)",
        padding: "10px 14px 12px",
        display: "flex",
        flexDirection: "column",
        gap: 8,
        fontFamily: BRAND.fontFamily,
        fontSize: 12,
        color: "#ff6b6b",
        zIndex: 200,
        position: "relative",
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
        <span
          className="material-symbols-outlined"
          aria-hidden
          style={{ fontSize: 18, marginTop: 1, flexShrink: 0 }}
        >
          lock
        </span>
        <div style={{ flex: 1, lineHeight: 1.4 }}>
          <div style={{ fontWeight: 700, letterSpacing: "0.04em" }}>
            SYSTEM LOCKDOWN
          </div>
          {reason && (
            <div style={{ marginTop: 2, color: "#ff6b6b", opacity: 0.9 }}>
              {reason}
            </div>
          )}
          <div style={{ marginTop: 4, color: "rgba(255,107,107,0.75)" }}>
            Contact:{" "}
            <a
              href={`mailto:${contactEmail}`}
              style={{
                color: "#ff6b6b",
                textDecoration: "underline",
                fontWeight: 600,
                wordBreak: "break-all",
              }}
            >
              {contactEmail}
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={onDismiss}
          style={{
            background: "rgba(255,107,107,0.2)",
            border: "0.5px solid rgba(255,107,107,0.3)",
            borderRadius: 6,
            color: "#ff6b6b",
            padding: "8px 14px",
            cursor: "pointer",
            fontFamily: BRAND.fontFamily,
            fontSize: 11,
            fontWeight: 600,
            minHeight: 36,
            touchAction: "manipulation",
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default LockdownBannerMobile;
